/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-08-13
 */

import { httpClient } from "./httpClient";
import {
  DashboardProjectAnalyticsApiResponse,
  DashboardProjectAnalyticsQuery,
} from "../features/dashboard/model/types";

const PROJECT_WISE_ANALYTICS_PATH = "company/analytics/project_wise/v2";

export const getProjectWiseAnalyticsApi = async (
  input: DashboardProjectAnalyticsQuery = {}
): Promise<DashboardProjectAnalyticsApiResponse> => {
  const response = await httpClient.get<DashboardProjectAnalyticsApiResponse>(
    PROJECT_WISE_ANALYTICS_PATH,
    {
      params: {
        association_type: input.associationType,
        page: input.page,
        page_size: input.pageSize,
        paginate: input.paginate,
      },
    }
  );

  return response.data;
};
